import { render } from "./LanguagePage.vue?vue&type=template&id=87c04038&ts=true"
import script from "./LanguagePage.vue?vue&type=script&lang=tsx"
export * from "./LanguagePage.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__